import axiosInstance from "../../interceptor/intercetptor-inctence"



export const itemsMaster = (data) => {
	const formData = new URLSearchParams(data); // converts to x-www-form-urlencoded
	// const header = {
	// 	"Content-Type": "application/x-www-form-urlencoded"
	// }
	return axiosInstance.post(`pharma/get-on-search`, data);
	// return axiosInstance.post(`superadmin/masterItemList`, {});
}

export const addStock = (data) => {
	return axiosInstance.post(`pharma/add-stock`, data);
	// return axiosInstance.post(`superadmin/masterItemList`, data);
}

// Get All Stocks
export const getStockList = (data) => {
	return axiosInstance.post(`pharma/get-purchase`, data);
	// return axiosInstance.post(`superadmin/getPurchaseList`, data);
}

// pay pending purchase payment
export const PayPurchasePayment = (data) => {
	return axiosInstance.post(`pharma/pay-pending-purchase`, data);
	// return axiosInstance.post(`superadmin/getPurchaseList`, data);
}

// View Stock Details by ID
export const viewStockDetails = (data) => {
	return axiosInstance.post(`pharma/view-purchase-details`, data);
}

// Update Stock Details by ID
export const updatePurchaseDetails = (data) => {
	return axiosInstance.patch(`pharma/update-purchase`, data);
}

// Get Stock Items List by Purchase ID
export const getStockItemsList = (data) => {
	return axiosInstance.post(`pharma/get-stocks`, data);
}

// View Stock Item Details by ID
export const getStockItemDetails = (data) => {
	return axiosInstance.post(`pharma/view-stock-details`, data);
}

// Return Purchase Items
export const returnPurchase = (data) => {
	return axiosInstance.post(`pharma/return-stock`, data);
}


export const createStockAPI = (data) => {
	return axiosInstance.post(`pharma/create-stock`, data);
}